/* Vacances Bonifacio — feuilles et particules */
(function () {
  if (window.__vbNatureEffectsLoaded) return;
  window.__vbNatureEffectsLoaded = true;

  function initNatureEffects() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.querySelector('.vb-nature-fx')) return;

    var root = document.createElement('div');
    root.className = 'vb-nature-fx';
    root.setAttribute('aria-hidden', 'true');

    var particlesLayer = document.createElement('div');
    particlesLayer.className = 'vb-nature-fx__particles';

    var leavesLayer = document.createElement('div');
    leavesLayer.className = 'vb-nature-fx__leaves';

    root.appendChild(particlesLayer);
    root.appendChild(leavesLayer);
    document.body.appendChild(root);

    var particleCount = window.innerWidth < 768 ? 16 : 28;
    var leafCount = window.innerWidth < 768 ? 7 : 12;

    for (var i = 0; i < particleCount; i++) {
      var p = document.createElement('span');
      p.className = 'vb-particle';
      var size = (Math.random() * 8 + 4).toFixed(2) + 'px';
      p.style.width = size;
      p.style.height = size;
      p.style.left = (Math.random() * 100).toFixed(2) + '%';
      p.style.top = (Math.random() * 100).toFixed(2) + '%';
      p.style.animationDuration = (Math.random() * 12 + 12).toFixed(2) + 's';
      p.style.animationDelay = (-Math.random() * 18).toFixed(2) + 's';
      p.style.setProperty('--vb-drift-x', ((Math.random() * 72) - 36).toFixed(2) + 'px');
      p.style.setProperty('--vb-rise', (Math.random() * 220 + 120).toFixed(2) + 'px');
      particlesLayer.appendChild(p);
    }

    for (var j = 0; j < leafCount; j++) {
      var l = document.createElement('span');
      l.className = 'vb-leaf';
      l.style.left = (Math.random() * 100).toFixed(2) + '%';
      l.style.animationDuration = (Math.random() * 8 + 14).toFixed(2) + 's';
      l.style.animationDelay = (-Math.random() * 20).toFixed(2) + 's';
      l.style.setProperty('--vb-leaf-w', (Math.random() * 14 + 14).toFixed(2) + 'px');
      l.style.setProperty('--vb-leaf-x', ((Math.random() * 180) - 90).toFixed(2) + 'px');
      l.style.setProperty('--vb-leaf-r', (Math.random() * 540 + 180).toFixed(2) + 'deg');
      leavesLayer.appendChild(l);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNatureEffects);
  } else {
    initNatureEffects();
  }
})();
